export type AddInvestorRefusalCode =
	| 'NOT_MULTI_SIGN'
	| 'UNSUPPORTED_PROVIDER'
	| 'NO_OUTSTANDING_SIGNATURES'
	| 'DOCUMENT_CLOSED'
	| 'PERSONALISED_DOCUMENT'
	| 'SIGNATURE_HEADROOM_EXHAUSTED';

// Mirrors REFUSAL_MESSAGES in libs/modules/src/documentWorkflow/addInvestors/addInvestors.types.ts.
// The frontend can't import from libs/modules, so this is a deliberate duplicate — keep it in sync.
export const REFUSAL_COPY: Record<AddInvestorRefusalCode, string> = {
	SIGNATURE_HEADROOM_EXHAUSTED:
		'Adding a signature would require a new signature page, which would invalidate the signatures already collected.',
	NO_OUTSTANDING_SIGNATURES: 'This document has no outstanding signatures.',
	DOCUMENT_CLOSED: 'This document is no longer open for signature.',
	NOT_MULTI_SIGN: 'Only multi-signature documents can take an extra investor.',
	UNSUPPORTED_PROVIDER: "This document's signing method does not support adding an investor.",
	PERSONALISED_DOCUMENT:
		'This document is personalised per investor, so an investor cannot be added to it.',
};

/** Refusals that are facts about the document's type, not something a manager can resolve here.
 *  The control is hidden entirely for these rather than shown permanently disabled. */
export const STRUCTURAL_REFUSALS: ReadonlySet<string> = new Set<AddInvestorRefusalCode>([
	'NOT_MULTI_SIGN',
	'UNSUPPORTED_PROVIDER',
	'PERSONALISED_DOCUMENT',
]);

export interface EligibleInvestor {
	id: string;
	name: string;
}
